import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../button/button'
import { Icon } from '../icon/icon'
import Modal from '../modal/modal'
import Text from '~/components/text/text'
import SocialLinks from '../social-links/social-links'
import { Spacer } from '../spacer/spacer'

interface ShareEventModalProps {
	toggleModal: () => void
}

export default function ShareEventModal({ toggleModal }: ShareEventModalProps) {
	const [url, seturl] = useState('')
	const handleCopyLink = () => {
		navigator.clipboard.writeText(url)
		toggleModal()
	}
	const { t } = useTranslation()
	useEffect(() => {
		seturl(window.location.href)
	}, [])
	return (
		<Modal onClose={toggleModal} title={t('share_event_title')}>
			<div className="flex flex-col">
				<div className="py-4">
					<Text>
						{t('share_event_description', { iconOne: '🎉', iconTwo: '😍' })}
					</Text>
				</div>
				<Spacer size="4xs" />
				<div className="flex flex-col space-y-4">
					<div className="border-border flex overflow-hidden rounded-md border">
						<input
							type="text"
							readOnly
							value={url}
							className="bg-card flex-grow truncate border-none px-3 py-2 text-sm outline-none"
						/>
						<Button
							variant="secondary"
							onClick={handleCopyLink}
							className="rounded-none px-4"
						>
							<Icon name="copy" className="mr-2" />
							{t('action_copy')}
						</Button>
					</div>

					<div className="mt-2 flex justify-center">
						<SocialLinks />
					</div>
				</div>
			</div>
		</Modal>
	)
}
